export const secondToMS = (second: number) => {
  const m = Math.floor((second % 3600) / 60);
  const s = Math.floor((second % 3600) % 60);

  if (m < 1 && s < 1) return '00:00';

  return `${String(`0${m}`).slice(-2)}:${String(`0${s}`).slice(-2)}`;
};
